import { Link } from '@inertiajs/react'

export interface CompanyHandoffData {
  ready: boolean
  can_setup: boolean
  recovery: boolean
  obligation: string
  deadline: string | null
  last_covered_day: string | null
  message: string
  path: string
}

export default function CompanyHandoff({ handoff }: { handoff?: CompanyHandoffData | null }) {
  if (!handoff) return null
  return <aside className="border border-stone/20 bg-white px-4 py-3 text-sm text-text-primary" aria-label="Company payment setup">
    <p>{handoff.message}</p>
    <p>{handoff.recovery ? 'Original billing boundary' : handoff.ready ? 'Scheduled first billing boundary' : 'Setup deadline'}: {handoff.deadline || 'Awaiting confirmation'}.</p>
    <Link href={handoff.path} className="underline font-semibold">{handoff.can_setup ? 'Set up company payment' : 'View payment setup'}</Link>
  </aside>
}
